import { Injectable } from '@angular/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';


export const authConfig: AuthConfig = {
  // Url of the Identity Provider
  issuer: 'https://localhost:44381',

  // URL of the SPA to redirect the user to after login
  redirectUri: "http://localhost:4200/dashboard/dashboard-landing",

  // The SPA's id. The SPA is registered with this id at the auth-server
  clientId: 'CC-FE-APP',

  // set the scope for the permissions the client should request
  // The first three are defined by OIDC. The 4th is a usecase-specific one
  scope: 'identitykeymanagement.full_access',
  strictDiscoveryDocumentValidation: false,
  responseType: 'code',
  requestAccessToken: true
}

@Injectable({
  providedIn: 'root'
})

export class GlobalDataService {
  public idToken: string = '';
  public accessToken: string = '';

  constructor(private oauthService: OAuthService) { }
  logout() {
    this.oauthService.logOut();
  }

  sendToForgotPassword() {
    this.oauthService.logOut(false);
  }

  getTokenclaims() {
    const claims: any = this.oauthService.getIdentityClaims();
    return claims ? claims : null;
  }

  getAccessToken() {
    return this.oauthService.getAccessToken();
  }

  getIdToken() {
    return this.oauthService.getIdToken();
  }

  hasValidAccessToken() {
    return this.oauthService.hasValidAccessToken();
  }

  hasValidIdToken() {
    return this.oauthService.hasValidIdToken();
  }

  setAccessToken(token: string) {
    this.accessToken = token;
  }

  setIdToken(token: string) {
    this.idToken = token;
  }

  getGlobalIdToken() {
    return this.idToken;
  }

  getGlobalAccessToken() {
    return this.accessToken;
  }

  isGlobalIdTokenExists() {
    return this.idToken ? true : false;
  }

  isGlobalAccessTokenExists() {
    return this.accessToken ? true : false;
  }
}
